export const EOM = 'EOM';
export const FF = 'FF';
export const MAF = 'MAF';
export const OVIK = 'OVIK';

export const ACCOUNTING_SUBTYPE = {
  FF: 'Отделка и меблировка',
  EOM: 'ЭОМ',
  OVIK: 'ОВиК, ВК',
  MAF: 'Общестрой, МАФ',
};
